import React, { useState } from 'react';
import exampleImg from '../../assets/qc35-caseware-screenshot-example.jpg';
import { hintOf } from '../../utils/uploadKinds';

// CaseWare Audit Working Papers Screenshot（Form QC35 May 2026 修訂版）——
// 上傳欄的說明句與範例圖，New／Modify modal／Management 記錄表單三面共用，
// 文字照 Word 表格的 Note 原句。
export const QC35_SCREENSHOT_HINT = `Provide a clear screenshot of your CaseWare Audit Working Papers’ Engagement History showing the File Locked Down date and the name of the engagement and financial year-end, as illustrated in the example. ${hintOf('images')}`;

// 範例圖預設收合成一行連結——表單已經很長，圖不搶戲；點開就地展開。
const Qc35ScreenshotExample = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-xs text-blue-600 hover:text-blue-800 underline"
      >
        {open ? 'Hide Example Screenshot' : 'View Example Screenshot'}
      </button>
      {open && (
        <div className="mt-2 border border-slate-200 rounded-lg p-3 bg-slate-50">
          <p className="text-xs font-medium text-slate-500 mb-2">
            Example — the CaseWare lockdown info with the File Locked Down date:
          </p>
          <img
            src={exampleImg}
            alt="Example CaseWare Audit Working Papers screenshot showing the lockdown date"
            className="max-w-full rounded border border-slate-200"
          />
        </div>
      )}
    </div>
  );
};

export default Qc35ScreenshotExample;
